"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppReadyResponseToJSON = exports.SignerAppReadyResponseFromJSONTyped = exports.SignerAppReadyResponseFromJSON = exports.instanceOfSignerAppReadyResponse = exports.attributeTypeMapSignerAppReadyResponse = void 0;
var SignerAppReadyResponseError_1 = require("./SignerAppReadyResponseError");
exports.attributeTypeMapSignerAppReadyResponse = [
    {
        name: "ready",
        type: "boolean",
    },
    {
        name: "pagesConverted",
        type: "number",
    },
    {
        name: "pagesSynced",
        type: "number",
    },
    {
        name: "pagesTotal",
        type: "number",
    },
    {
        name: "isInFlightEditing",
        type: "boolean",
    },
    {
        name: "token",
        type: "string",
    },
    {
        name: "error",
        type: "SignerAppReadyResponseError",
    },
    {
        name: "successfulTags",
        type: "Array<string>",
    },
];
/**
 * Check if a given object implements the SignerAppReadyResponse interface.
 */
function instanceOfSignerAppReadyResponse(value) {
    if (!("ready" in value) || value["ready"] === undefined)
        return false;
    if (!("pagesConverted" in value) || value["pagesConverted"] === undefined)
        return false;
    if (!("pagesSynced" in value) || value["pagesSynced"] === undefined)
        return false;
    if (!("pagesTotal" in value) || value["pagesTotal"] === undefined)
        return false;
    if (!("isInFlightEditing" in value) ||
        value["isInFlightEditing"] === undefined)
        return false;
    if (!("token" in value) || value["token"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerAppReadyResponse = instanceOfSignerAppReadyResponse;
function SignerAppReadyResponseFromJSON(json) {
    return SignerAppReadyResponseFromJSONTyped(json, false);
}
exports.SignerAppReadyResponseFromJSON = SignerAppReadyResponseFromJSON;
function SignerAppReadyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ready: json["ready"],
        pagesConverted: json["pages_converted"],
        pagesSynced: json["pages_synced"],
        pagesTotal: json["pages_total"],
        isInFlightEditing: json["isInFlightEditing"],
        token: json["token"],
        error: json["error"] == null
            ? undefined
            : (0, SignerAppReadyResponseError_1.SignerAppReadyResponseErrorFromJSON)(json["error"]),
        successfulTags: json["successful_tags"] == null ? undefined : json["successful_tags"],
    };
}
exports.SignerAppReadyResponseFromJSONTyped = SignerAppReadyResponseFromJSONTyped;
function SignerAppReadyResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        ready: value["ready"],
        pages_converted: value["pagesConverted"],
        pages_synced: value["pagesSynced"],
        pages_total: value["pagesTotal"],
        isInFlightEditing: value["isInFlightEditing"],
        token: value["token"],
        error: (0, SignerAppReadyResponseError_1.SignerAppReadyResponseErrorToJSON)(value["error"]),
        successful_tags: value["successfulTags"],
    };
}
exports.SignerAppReadyResponseToJSON = SignerAppReadyResponseToJSON;
